import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const BILLING_TYPE_SCHEMA = order.orderService.versions.v1.schemas.BILLING_TYPE_SCHEMA;
export type BILLING_TYPE = z.infer<typeof BILLING_TYPE_SCHEMA>;
